<template>
  <div>
    <!-- 중요 프로세스 -->
    <div v-show="!isEmpty(processData) && isTrue(processData.isAbnormal)" class="mr-b25">
      <div class="title-bar">
        <div class="tit content-title">중요 프로세스</div>
        <span v-if="isTrue(processData.isAbnormal)" class="abnormal-message">
          {{ processData.abnormalMessage }}
        </span>
      </div>
      <el-table-wrapper :data="isEmpty(processData) || isEmpty(processData.etcData) ? [] : processData.etcData" :columns="processColumns" :column-default="columnDefault" :pagination="false">
        <template slot-scope="scope" slot="cpu-slot">
          <el-progress v-if="scope.row.procCpuUserate > 0" :class="getCpuProgressbarClass(scope.row.procCpuUserate)" :text-inside="true" :stroke-width="18" :percentage="scope.row.procCpuUserate"></el-progress>
          <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
        </template>
        <template slot-scope="scope" slot="memory-slot">
          <span :class="getMemValueClass(scope.row.procMemUsedSize)">{{getConvertMemValuByUnit(scope.row.procMemUsedSize)}}</span>
        </template>
      </el-table-wrapper>
    </div>
    <!-- 어플리케이션 로그 -->
    <div v-show="visibleAppLogInfo">
      <el-row type="flex" class="title-bar" justify="space-between">
        <div>
          <div class="tit content-title">어플리케이션 로그</div>
          <span class="condition-text">({{ logPeriodLabel }})</span>
          <span v-if="isTrue(appLogEventTimeData.isAbnormal)" class="abnormal-message">
            {{ appLogEventTimeData.abnormalMessage }}
          </span>
        </div>
        <div>
          <el-radio-group class="mr-r10" v-model="searchLogType" @change="loadData">
            <el-radio label="origin">원본 로그</el-radio>
            <el-radio label="filtering">필터링 로그</el-radio>
          </el-radio-group>
          <el-select v-model="searchTypeCheck" v-show="searchLogType === 'filtering'" :disabled="searchLogType === 'origin'" @change="loadData">
            <el-option label="전체" value="total"></el-option>
            <el-option label="확인" value="checked"></el-option>
            <el-option label="미확인" value="unchecked"></el-option>
          </el-select>
          <w-header-search-button size="mini" @click="showApplogSearchTool = !showApplogSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-row>
        <el-table-wrapper :data="applogTableData" :columns="applogColumns" :total="applogTotal" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showApplogSearchTool"
        ref="logTable" :show-overflow-tooltip="true" :pagination="true" remote @condition-change="loadLogData">
        <template slot-scope="scope" slot="is-checked-slot">
          <span v-if="scope.row.isChecked === '1'">확인</span>
          <span v-else-if="scope.row.isChecked === '0'">미확인</span>
          <span v-else>-</span>
        </template>
        </el-table-wrapper>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty, findIndex, cloneDeep, concat, forEach } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { getDateToString, getIntervalDatetimeParams } from '@/utils/date';
import { isTrue } from '@/utils/boolean';
import MsgUtil from '@/utils/message';
import APPLogAPI from '@/api/log/common';
import ServerTableInfoAPI from '@/api/performance/server/info-table';
import { etcInfoDefine } from '../../../constants/fault-analysis';
import { getLogPeriodCondition, getPeriodConditionLabel } from '../../../utils/fault-analysis';

export default {
  name: 'WServerEtcInfoView',
  props: {
    /**
     * 기타 분석 정보 조회 시 필요한 정보 객체 (동시성 문제 고려하여 하나의 객체로 전달)
     * 1) obj: 분석 대상 장비 정보
     * 2) eventHistData: 분석 이벤트 이력 정보
     * 3) etcInfo: 기타 분석 정보
     * @type {Object}
     */
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnDefault,
      /* 어플리케이션 로그 */
      showApplogSearchTool: false,
      searchLogType: 'origin',
      searchTypeCheck: 'total',
      applogTotal: 0,
      applogTableData: [],
      appLogEventTimeData: {}, // 이벤트 발생 시점 어플리케이션 로그 자원 정보
      appLogLoaded: false, // 어플리케이션 로그 최초 로드 완료 여부
      visibleAppLogInfo: false, // 어플리케이션 로그 정보 제공 여부.
      filteringLogColumns: [
        // {
        //   type: 'selection',
        //   width: '50',
        // },
        {
          prop: 'isChecked',
          label: '상태',
          width: 60,
          scopedSlot: 'is-checked-slot',
        },
      ],
      /* 중요 프로세스 */
      processData: {},
      processOccupationLimit: {},
      processColumns: [
        {
          prop: 'procStatus',
          label: '동작상태',
          formatter: this.formatterForStatusAlive,
          width: 100,
        },
        {
          prop: 'procName',
          label: '프로세스명',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'procCpuUserate',
          label: 'CPU (%)',
          align: 'center',
          scopedSlot: 'cpu-slot',
          width: 150,
        },
        {
          prop: 'procMemUsedSize',
          label: '메모리',
          scopedSlot: 'memory-slot',
          width: 120,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['activeManagetypeIds']),
    isLms() {
      return findIndex(this.activeManagetypeIds, (item) => item === 'LMS') >= 0;
    },
    applogColumns() {
      let applogColumns = cloneDeep(this.filteringLogColumns);
      if (!this.isLms) {
        applogColumns = concat(applogColumns, [
          {
            prop: 'filterName',
            label: '필터',
            width: 150,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'message',
            label: '메시지',
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: '@timestamp',
            label: '수집시각',
            showOverflowTooltip: true,
            formatter: this.getDateFormatter,
            width: 200,
          },
        ]);
      } else {
        applogColumns = concat(applogColumns, [
          {
            prop: 'sourceName',
            label: '로그 소스',
            width: 150,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'originMessage',
            label: '원본 메시지',
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'filterName',
            label: '정책 이름',
            width: 150,
            searchable: true,
            formatter: this.getStringFormatter,
          },
          {
            prop: 'timestamp',
            label: '수집 시간',
            width: 160,
            searchable: true,
            searchType: 'date',
            formatter: this.getDateFormatter,
          },
        ]);
      }

      return applogColumns;
    },
    logPeriodLabel() {
      if (isEmpty(this.data) || isEmpty(this.data.eventHistData)) {
        return EMPTY_TEXT;
      }
      const period = getLogPeriodCondition(this.data.eventHistData.checkDatetime);
      return getPeriodConditionLabel(period.startDatetime, period.endDatetime);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(to) {
        this.reset();
        if (!isNil(to)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    isEmpty,
    isTrue,
    /**
     * 서버의 기타 분석 정보 조회
     * @author jeee12
     */
    loadData() {
      this.loadLogData();
      this.setMajorProcessData();
    },
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      // 어플리케이션 로그
      this.applogTableData = [];
      this.applogTotal = 0;
      this.appLogEventTimeData = {};
      this.appLogLoaded = false;
      this.visibleAppLogInfo = false;
      // 프로세스
      this.processData = {};
      this.processOccupationLimit = {};
    },
    /**
     * [어플리케이션 로그] 데이터 조회
     * @author jeee12
     */
    loadLogData() {
      if (!isEmpty(this.data) && !isEmpty(this.data.etcInfo) && !isEmpty(this.data.etcInfo[etcInfoDefine.SERVER_APPLOG])) {
        this.appLogEventTimeData = this.data.etcInfo[etcInfoDefine.SERVER_APPLOG];
      }
      if (!isEmpty(this.data.eventHistData)) {
        this.$nextTick(() => {
          const params = this.setLogSearchParams();
          APPLogAPI.getLogAnalysisData(params).then((response) => {
            if (response.data.success) {
              this.applogTableData = response.data.data;
              this.applogTotal = response.data.total;
            } else {
              this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '어플리케이션 로그 정보', false));
            }
          }).catch((e) => {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '어플리케이션 로그 정보', false));
            throw new Error(e);
          }).finally(() => {
            if (!this.appLogLoaded) {
              this.appLogLoaded = true;
              this.visibleAppLogInfo = this.applogTotal > 0;
            }
          });
        });
      }
    },
    /**
     * 로그 날짜 formatter
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {String}
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        if (this.isLms) {
          return getDateToString(getIntervalDatetimeParams(value, 'hour', 9), 'YYYY-MM-DD HH:mm:ss');
        }
        return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    /**
     * 공백 문자열 체크 formatter
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {String}
     */
    getStringFormatter(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [어플리케이션 로그] 데이터 조회를 위한 파라미터 설정
     * @author jeee12
     */
    setLogSearchParams() {
      const periodCondition = getLogPeriodCondition(this.data.eventHistData.checkDatetime);
      const tableSearchParams = this.$refs.logTable.getParameter();

      console.debug(periodCondition.startDatetime, periodCondition.endDatetime);
      // 기본 파라미터
      const queryList = [{ field: 'logType', value: 'APP', operator: 'AND', regex: 'N' }, { field: 'objId', value: this.data.obj.objId, operator: 'AND', regex: 'N' }];
      const params = {
        objId: this.data.obj.objId,
        logType: 'APP',
        type: 'performance',
        startDateTime: periodCondition.startDatetime,
        endDateTime: periodCondition.endDatetime,
        start: tableSearchParams.start,
        limit: tableSearchParams.limit,
        queryList,
      };

      // 헤더 검색어 추가
      if (!isNil(tableSearchParams.searchParams)) {
        forEach(tableSearchParams.searchParams, (item) => {
          queryList.push({ field: item.field, value: item.value, operator: 'AND' });
        });
        params.queryList = queryList;
      }

      // 1. 원본/필터링 로그 조회 타입 추가 (라디오)
      if (this.searchLogType === 'filtering') {
        // 필터링 로그
        params.queryList.push({ field: 'filterId', operator: 'EXIST' });

        // 2. 확인/미확인 조회 타입 추가 (콤보박스)
        if (this.searchTypeCheck === 'checked') {
          // 확인만
          params.queryList.push({ field: 'isChecked', value: '1', operator: 'AND' });
        } else if (this.searchTypeCheck === 'unchecked') {
          // 미확인만
          params.queryList.push({ field: 'isChecked', value: '0', operator: 'AND' });
        }
      }

      return params;
    },
    /**
     * 중요 프로세스 데이터를 설정한다.
     * @author Ju
     */
    setMajorProcessData() {
      if (!isEmpty(this.data) && !isEmpty(this.data.etcInfo) && !isEmpty(this.data.etcInfo.SERVER_MAJOR_PROC) && isTrue(this.data.etcInfo.SERVER_MAJOR_PROC.isAbnormal)) {
        ServerTableInfoAPI
          .getProcessOverloadSettings(this.data.obj.objId)
          .then((response) => {
            if (response.data.success === true) {
              const result = response.data.data;
              this.processOccupationLimit = {
                CPU: result.processMaxCpuLimit,
                MEM: result.processMaxMemLimit * 1024,
              };
            }
          }).finally(() => {
            this.processData = this.data.etcInfo[etcInfoDefine.SERVER_MAJOR_PROC];
          });
      } else {
        this.processData = {};
      }
    },
    /**
     * 프로세스 상태 formatter
     * @author Ju
     * @param  {[type]} row [description]
     */
    formatterForStatusAlive(row, column, value) {
      let statusAlive;
      if (isNil(value)) {
        statusAlive = EMPTY_TEXT;
      } else if (isTrue(value)) {
        statusAlive = '정상 동작';
      } else {
        statusAlive = '다운 상태';
      }
      return statusAlive;
    },
    /**
     * 메모리 사용량 단위를 환산한다.
     * @author Ju
     * @param  {Number} value 메모리 사용량
     * @return {String}
     */
    getConvertMemValuByUnit(value) {
      return convertValuByUnit(value, 'KB', true, false, true);
    },
    /**
     * CPU 사용률에 대한 상태 클래스 반환
     * @author Ju
     * @param  {Number} value CPU 사용률
     * @return {String}       클래스명
     */
    getCpuProgressbarClass(value) {
      if (!isNil(this.maxCpuLimit) && value >= this.maxCpuLimit) {
        return 'abnormal';
      }
      return null;
    },
    /**
     * 메모리 사용량에 대한 상태 클래스 반환
     * @author Ju
     * @param  {Number} value 메모리 사용량
     * @return {String}       클래스명
     */
    getMemValueClass(value) {
      if (!isNil(this.maxMemLimit) && value > this.maxMemLimit) {
        return 'state-abnormal';
      }
      return null;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/EtcInfo/ServerEtcInfoView.vue